import * as React from "react";
const SvgCollapse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 9H0v1.5h2.797L0 13.297.703 14 3.5 11.203V14H5zm6.203-5.5L14 .703 13.297 0 10.5 2.797V0H9v5h5V3.5z" }));
export default SvgCollapse;
